import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { TooltipModule } from 'primeng/tooltip';
import { ChartModule } from 'primeng/chart';
import { MessagesModule } from 'primeng/messages';
import { TabViewModule } from 'primeng/tabview';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

import { CoreModule } from 'src/app/core/core.module';
import { PlatformHealthRoutingModule } from './platform-health-routing.module';
import { PlatformHealthDashboardComponent } from './platform-health-dashboard/platform-health-dashboard.component';
import { PlatformHealthOverviewComponent } from './platform-health-overview/platform-health-overview.component';
import { PlatformHealthApiComponent } from './platform-health-api/platform-health-api.component';
import { PlatformHealthDatabaseComponent } from './platform-health-database/platform-health-database.component';
import { PlatformHealthIndicatorComponent } from './platform-health-indicator/platform-health-indicator.component';
import { PlatformHealthApiIndicatorsComponent } from './platform-health-api-indicators/platform-health-api-indicators.component';
import { PlatformHealthDatabaseIndicatorsComponent } from './platform-health-database-indicators/platform-health-database-indicators.component';
import { PlatformHealthChartComponent } from './platform-health-chart/platform-health-chart.component';
import { PlatformHealthHelpIconComponent } from './platform-health-help-icon/platform-health-help-icon.component';

@NgModule({ declarations: [
        PlatformHealthDashboardComponent,
        PlatformHealthOverviewComponent,
        PlatformHealthApiComponent,
        PlatformHealthDatabaseComponent,
        PlatformHealthIndicatorComponent,
        PlatformHealthApiIndicatorsComponent,
        PlatformHealthDatabaseIndicatorsComponent,
        PlatformHealthChartComponent,
        PlatformHealthHelpIconComponent
    ], imports: [CoreModule,
        PlatformHealthRoutingModule,
        CommonModule,
        FormsModule,
        TableModule,
        ButtonModule,
        DropdownModule,
        TooltipModule,
        ChartModule,
        MessagesModule,
        TabViewModule,
        ConfirmDialogModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class PlatformHealthModule { }
